import { render, staticRenderFns } from "./GoTime.vue?vue&type=template&id=4d767222&scoped=true&"
import script from "./GoTime.vue?vue&type=script&lang=js&"
export * from "./GoTime.vue?vue&type=script&lang=js&"
import style0 from "./GoTime.vue?vue&type=style&index=0&id=4d767222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d767222",
  null
  
)

export default component.exports